export default __webpack_public_path__ + "static/media/logo.845a497d.png";